import MqttSingleton from './rabbitmq';

export { default as routingKeys } from './routingKeys';
export { default as topics } from './topics';

export const mqtt = MqttSingleton.getInstance();

export default mqtt;
